module.exports = function (storePicker, storePickerPanelService, atm, $timeout, $rootScope) {
    return {
        restrict: 'E',
        scope: {},
        transclude: true,
        link(scope) {
            scope.storePicker = storePicker;
            scope.storePickerPanelService = storePickerPanelService;
            scope.hideFeaturePromo = false;
            scope.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            scope.$watch('storePickerPanelService.deliverySearch.FulfilmentStoreID', function () {
                scope.invokeDeliveryOverlayViewAnalytics();
            }, true);

            scope.invokeDeliveryOverlayViewAnalytics = function () {
                const result = scope.storePicker.fulfilmentInfo.FulfilmentMethod === 'Pick Up' &&
                    scope.storePickerPanelService.deliverySearch.FulfilmentStoreID &&
                    scope.storePicker.delivery.allowed;

                if (result) {
                    const atmData = {
                        event: 'BWSAUdeliveryOverlay',
                        store: {
                            DeliveryOverlayAddress: storePickerPanelService.deliverySearch.SuburbName,
                            DeliveryOverlayInteraction: 'view'
                        }
                    };

                    atm.pushWithStoreMapper(atmData);
                }
            };

            scope.close = function () {
                this.hideFeaturePromoPanel();

                const atmData = {
                    event: 'BWSAUdeliveryOverlay',
                    store: {
                        DeliveryOverlayAddress: storePickerPanelService.deliverySearch.SuburbName,
                        DeliveryOverlayInteraction: 'close'
                    }
                };

                atm.pushWithStoreMapper(atmData);
            };

            scope.hideFeaturePromoPanel = function () {
                scope.hideFeaturePromo = true;
            };

            $rootScope.$on('featurePromo:close', scope.close);
            $rootScope.$on('featurePromo:hideFeaturePromoPanel', scope.hideFeaturePromoPanel);
        },
        template: require('./feature-promo-template.html')
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/feature-promo/feature-promo-directive.js
 **/